import { AlpineComponent } from 'alpinejs';

type HistoryBlockData = {
  visible: boolean;
};

const HistoryBlock = (): AlpineComponent<HistoryBlockData> => ({
  visible: false,

  async init() {
    const { default: initApp } = await import(
      /* webpackChunkName: "history-block-appp" */ './app'
    );

    const config = JSON.parse(this.$refs.config.innerHTML);

    initApp(config, this.$refs.root);
  }
});

export default HistoryBlock;
